/**
 * Break apart words
 */

export default function tokenize(string) {
  return string.split(/\s+/);
}
